'use client'
import Link from 'next/link'
import React from 'react'
import { useRouter } from 'next/navigation'

export default function Notfound({ message, onRetry = null }) {
  if (onRetry == null) {
    const router = useRouter()
    onRetry = () => router.refresh()
  }
  return (
    <section className="page-not-found">
      <div className="content container pt-4 pt-xl-5">
        <h2 className="mb-3">OOPS!</h2>
        <h3 className="mb-3">找不到內容</h3>
        <p className="mb-3">{message}</p>
        <Link
          href={'/'}
          className="btn btn-primary d-flex align-items-center justify-content-center mx-auto"
        >
          回首頁
        </Link>
        <button
          className="btn btn-secondary d-flex align-items-center justify-content-center mx-auto"
          onClick={onRetry}
        >
          重新載入
        </button>
      </div>
    </section>
  )
}
